export default __webpack_public_path__ + "static/media/attachment.b7dffb3f.svg";